// Utils
import { createNamespace, isDef, noop } from '../utils';
import { inherit } from '../utils/functional';
import { preventDefault } from '../utils/dom/event';
const [createComponent, bem] = createNamespace('overlay');
function preventTouchMove(event) {
    preventDefault(event, true);
}
function Overlay(h, props, slots, ctx) {
    const style = {
        zIndex: props.zIndex,
        ...props.customStyle,
    };
    if (isDef(props.duration)) {
        style.animationDuration = `${props.duration}s`;
    }
    return (<transition name="van-fade">
      <div vShow={props.show} style={style} class={[bem(), props.className]} onTouchmove={props.lockScroll ? preventTouchMove : noop} {...inherit(ctx, true)}>
        {slots.default?.()}
      </div>
    </transition>);
}
Overlay.props = {
    show: Boolean,
    zIndex: [Number, String],
    duration: [Number, String],
    className: null,
    customStyle: Object,
    lockScroll: {
        type: Boolean,
        default: true,
    },
};
export default createComponent(Overlay);
